import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { useAccountSpecialCondition } from './hook';
import { AccountSpecialConditionProps } from './props';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import FieldSelect from '../../../../../components/general/fields/fieldSelect';

export const AccountSpecialCondition = (
    props: AccountSpecialConditionProps
) => {
    const { formik, specialConditions } = useAccountSpecialCondition(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Condición especial
                </Typography>
            </Grid>
            <Grid item xs={12} md={8} lg={4}>
                <Checkbox
                    beforeLabel="Condición especial"
                    label="¿Presenta alguna condición especial?"
                    checked={Boolean(formik.values.hasSpecialCondition)}
                    onChange={() => {
                        formik.setFieldValue(
                            'hasSpecialCondition',
                            !formik.values.hasSpecialCondition
                        );
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            {formik.values.hasSpecialCondition && (
                <>
                    <Grid item xs={12} md={4} lg={8}>
                        <FieldSelect
                            data={specialConditions}
                            label="Tipo de persona contacto"
                            name="specialCondition"
                            size="small"
                            required
                            onBlur={formik.handleBlur}
                            touched={formik.touched.specialCondition}
                            errors={formik.errors.specialCondition}
                            value={formik.values.specialCondition as string}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FieldText
                            label="Observaciones"
                            name="observations"
                            size="small"
                            rows={3}
                            required
                            onBlur={formik.handleBlur}
                            touched={formik.touched.observations}
                            errors={formik.errors.observations}
                            value={formik.values.observations}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
};
